import { render, staticRenderFns } from "./carbonfootprintWapper.vue?vue&type=template&id=1093db40&scoped=true"
import script from "./carbonfootprintWapper.vue?vue&type=script&lang=js"
export * from "./carbonfootprintWapper.vue?vue&type=script&lang=js"
import style0 from "./carbonfootprintWapper.vue?vue&type=style&index=0&id=1093db40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1093db40",
  null
  
)

export default component.exports